/**
 * LOGOS Subscription Plugin — Capacitor bridge to native StoreKit 2
 * 
 * Product ID: "001" (Monthly auto-renewable subscription)
 * Subscription Group: "Logoilab Subscriber" (ID: 21924966)
 * 
 * @author Dr. José Manuel Cadena Ortiz de Montellano
 */

import { registerPlugin } from '@capacitor/core';

export interface SubscriptionProduct {
  id: string;
  displayName: string;
  description: string;
  displayPrice: string;
  price: number;
  isFamilyShareable: boolean;
  subscriptionPeriod: string;
}

export interface SubscriptionStatus {
  isPremium: boolean;
  productId: string;
  expirationDate: string;
  willAutoRenew: boolean;
}

export interface PurchaseResult {
  success: boolean;
  isPremium: boolean;
  transactionId?: string;
  productId?: string;
  reason?: string;
}

export interface RestoreResult extends SubscriptionStatus {
  restored: boolean;
}

export interface LOGOSSubscriptionPlugin {
  getSubscriptionStatus(): Promise<SubscriptionStatus>;
  getProducts(): Promise<{ products: SubscriptionProduct[] }>;
  purchase(options: { productId: string }): Promise<PurchaseResult>;
  restorePurchases(): Promise<RestoreResult>;
  manageSubscription(): Promise<{ opened: boolean }>;
}

const LOGOSSubscription = registerPlugin<LOGOSSubscriptionPlugin>('LOGOSSubscription');

export default LOGOSSubscription;

/** The product ID for the monthly premium subscription */
export const PREMIUM_PRODUCT_ID = '001';
